import { AfterViewInit, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { faForward as faForwardRegular } from '@fortawesome/pro-regular-svg-icons';
import { faForward as faForwardDuotone } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { PresenceStatusState } from '../../../store/samwin/contact-states/presence-status/presence-status.state';

@Component({
   selector: 'samweb-presence-status-forward-destination',
   templateUrl: './presence-status-forward-destination.component.html',
   styleUrls: ['./presence-status-forward-destination.component.scss'],
})
export class PresenceStatusForwardDestinationComponent implements AfterViewInit, OnDestroy, OnChanges {
   constructor(private store: Store) {}
   private destroy$ = new Subject();
   public noForwardIcon = faForwardRegular;
   public forwardIcon = faForwardDuotone;

   @Input()
   public fixedWidth: boolean;

   @Input()
   public presenceId: string;

   @Input()
   public presenceTypeValue: number;

   public forwardDestination$: Observable<string>;

   // Is needed for virtual scrolling, the data would not update correctly otherwise.
   ngOnChanges(changes: SimpleChanges): void {
      if (
         changes?.presenceId?.previousValue !== changes?.presenceId?.currentValue ||
         changes?.presenceTypeValue?.previousValue !== changes?.presenceTypeValue?.currentValue
      ) {
         this.ngAfterViewInit();
      }
   }

   ngAfterViewInit(): void {
      this.forwardDestination$ = this.store.select(PresenceStatusState.getPresenceStateSelector(this.presenceId, this.presenceTypeValue)).pipe(
         map((x) => (_.isNil(x.presenceState) ? null : x.presenceState.forwardDestination)),
         takeUntil(this.destroy$)
      );
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
